import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-0e51bdd7"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  id: "ongoing-cursor",
  slot: "start"
}
const _hoisted_2 = { class: "time" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  slot: "content",
  class: "ion-padding item-lines-full"
}
const _hoisted_5 = { class: "item-actions" }

import { IonAccordion, IonButton, IonIcon, IonItem, IonLabel, modalController } from '@ionic/vue'
import { createOutline } from 'ionicons/icons'
import ContentBlocks from '@/components/ContentBlocks.vue'
import TextFormatter from '@/components/TextFormatter.vue'

import { EventScheduleItem, useEventStore } from '@/store/event'

import { format } from '@/lib/date-fns-local'


export default /*#__PURE__*/_defineComponent({
  __name: 'ScheduleItem',
  props: {
    item: {},
    isCurrent: { type: Boolean }
  },
  setup(__props: any) {

const props = __props

async function editItem () {
  const ScheduleItemForm = await import('@/components/ScheduleItemForm.vue')
  return (await modalController.create({
    component: ScheduleItemForm.default,
    componentProps: { origItem: props.item },
    ...ScheduleItemForm.modalOptions
  })).present()
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonAccordion), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonItem), { slot: "header" }, {
        default: _withCtx(() => [
          (_ctx.isCurrent)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_2, [
            (_ctx.item.time.originalStart)
              ? (_openBlock(), _createElementBlock("s", _hoisted_3, _toDisplayString(_unref(format)(_ctx.item.time.originalStart, 'HH:mm')), 1))
              : _createCommentVNode("", true),
            _createTextVNode(" " + _toDisplayString(_unref(format)(_ctx.item.time.start, 'HH:mm')), 1)
          ]),
          _createVNode(_unref(IonLabel), null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.item.title), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          (_unref(useEventStore)().currentMember?.canWrite)
            ? (_openBlock(), _createBlock(_unref(IonButton), {
                key: 0,
                fill: "clear",
                size: "small",
                onClick: editItem
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonIcon), {
                    slot: "icon-only",
                    icon: _unref(createOutline)
                  }, null, 8, ["icon"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _createVNode(TextFormatter, {
          value: _ctx.item.description
        }, null, 8, ["value"]),
        _createVNode(ContentBlocks, {
          value: _ctx.item.blocks
        }, null, 8, ["value"])
      ])
    ]),
    _: 1
  }))
}
}

})